import { gql } from '@apollo/client';

export default gql`
  query pendingSubscriptionAcknowledgments {
    pendingSubscriptionAcknowledgments {
      required
      requiresPaymentMethod
      items {
        key
        source
        orderItemId
        patient {
          id
          firstName
          lastName
        }
        product {
          id
          name
          productType
          planStartInterval
          planSubscription {
            id
            name
            price
            renewalIntervalMonths
          }
        }
      }
      tiers {
        price
        overPrice
        units
        product {
          id
          name
          description
          price
          productType
          renewalIntervalMonths
        }
      }
    }
  }
`;
